// extracted by mini-css-extract-plugin
export default {"1100":"(min-width: 1100px)","root":"JiSvPWjaq_fKaLiSNvSS","wrap":"bQ5z4kqSUy8LBAoYnCCW","main":"Dz9OMOUuuCPzCCOnY_lJ","pane":"KAAl5S4ZySyZxgRr5WUV"};